import { CustomCard } from "../CustomCard/CustomCard";
import { Col, Collapse, Row, Tag, Tooltip } from "antd";
import {
  daysJsFormat,
  renderStatusTag,
  renderTypePrestation,
  renderUserName,
  roles,
} from "../../../utils/constants";
import React, { useContext } from "react";
import dayjs from "../../../utils/dayjs";
import { RenderUpdatedCopy } from "../RenderUpdatedCopy/RenderUpdatedCopy";
import { RenderDate } from "../../../pages/Prestations/PrestationResume/PrestationResumeCards";
import { InfoCircleOutlined } from "@ant-design/icons";
import { userHasLevel } from "../../../engine/AuthRoute";
import { Link } from "react-router-dom";
import routes from "../../../engine/routes";
import { colorPrimary } from "../../../root";
import { UserContext } from "../../../engine/context/User.context";
import { renderAdress } from "../../container/Addresses/AddresseItem/AddresseHelpers";

export const RenderBillInfo = ({ title, loading, bill }) => {
  const { user } = useContext(UserContext);


  const renderInformations = () => {
    const {
      reference,
      createdAt,
      bill_number,
      swico,
      institution,
      comment,
      comment_institution,
      prestations,
    } = bill;

    function groupPrestationsByType(prestations) {
      return (
        prestations?.reduce((acc, e) => {
          const type = e.intervention.type;
          if (!acc[type]) {
            acc[type] = 1;
          } else {
            acc[type]++;
          }
          return acc;
        }, {}) || {}
      );
    }

    const groupedPrestations = groupPrestationsByType(prestations);

    // Convert the grouped data to an array of strings, each containing a label and a count
    const displayData = Object.keys(groupedPrestations).map(type => {
      return `${renderTypePrestation(type)} (${groupedPrestations[type]})`;
    });

    function getUniqueInterpretes(prestations) {
      const seen = new Set();
      return prestations.filter(e => {
        if (seen.has(e.interprete._id)) {
          return false;
        } else {
          seen.add(e.interprete._id);
          return true;
        }
      });
    }
    const uniqueInterpretes = getUniqueInterpretes(prestations);

    const renderLinkHasAccess = prestation => {
      let canAccessLink = false;
      if (user.role === roles.admin || user.role === roles.permanance) {
        return true;
      } else {
        if (prestation.institutionBilling) {
        }

        return canAccessLink;
      }
    };

    return (
      <>
        <Row gutter={[10, 10]}>
          <Col span={12}>
            <span className={"resume-subtitle"}>
              <Tooltip
                title={
                  <span>
                    Basé sur le standard ISO 11649. Référence structurée de
                    créancier à l'information de remise
                    <br />
                    <a
                      href={"https://www.iso.org/fr/standard/50649.html"}
                      target="_blank"
                    >
                      Documentation
                    </a>{" "}
                  </span>
                }
                placement={"right"}
              >
                Numéro de référence facturation <InfoCircleOutlined />
              </Tooltip>
            </span>
            <span className={"resume-text"}>{reference}</span>
          </Col>
          <Col span={12}>
            <span className={"resume-subtitle"}>
              Numéro interne de la facture
            </span>
            <span className={"resume-strong"}>
              <Link to={routes.billing(bill._id).detail.path}>
                {bill_number}
              </Link>
            </span>
          </Col>{" "}
          <Col span={12}>
            <span className={"resume-subtitle"}>
              SWICO{" "}
              <Tooltip
                title={
                  <span>
                    Basé sur la norme Swico
                    <br />
                    <a
                      href={
                        "https://www.swico.ch/media/filer_public/1c/cd/1ccd7062-fc69-40f8-be3f-2a3ba9048c5f/v2_qr-bill-s1-syntax-fr.pdf"
                      }
                      target="_blank"
                    >
                      Définition syntaxique FR
                    </a>{" "}
                    <a
                      href={
                        "https://www.swico.ch/media/filer_public/20/76/2076a19a-a017-438a-bc9a-73b1a5980d00/v2_qr-bill-s1-syntax-de.pdf"
                      }
                      target="_blank"
                    >
                      Syntaxdefinition DE
                    </a>
                  </span>
                }
                placement={"right"}
              >
                Information supplémentaire <InfoCircleOutlined />
              </Tooltip>
            </span>
            <span className={"resume-text"}>{swico}</span>
          </Col>
          <Col span={12}>
            <span className={"resume-subtitle"}>Date de création</span>
            <RenderDate dataKey={"createdAt"} createdAt={createdAt} />
          </Col>
          <Col span={12}>
            <span className={"resume-subtitle"}>Institution</span>
            <span className={"resume-text"}>
              <Link to={routes.institutions(institution?._id).detail.path}>
                {institution?.name}
              </Link>
            </span>
          </Col>
          <Col span={12}>
            <span className={"resume-subtitle"}>Interprète</span>
            <span className={"resume-text"} style={{}}>
              {uniqueInterpretes.length > 5 ? (
                <Collapse size={"small"} style={{ width: "100%" }}>
                  <Collapse.Panel key={"all"} header={"Tout afficher"}>
                    {uniqueInterpretes.map(e => (
                      <Link
                        to={routes.interpretes(e.interprete._id).detail.path}
                        style={{ flex: 1 }}
                      >
                        {renderUserName(e.interprete) + ", "}
                      </Link>
                    ))}
                  </Collapse.Panel>
                </Collapse>
              ) : (
                <span>
                  {uniqueInterpretes.map(e => (
                    <Link
                      to={routes.interpretes(e.interprete._id).detail.path}
                      style={{ flex: 1 }}
                    >
                      {renderUserName(e.interprete) + " "}
                    </Link>
                  ))}
                </span>
              )}
            </span>
          </Col>
          <Col span={12}>
            <span className={"resume-subtitle"}>Type de prestation</span>
            <span className={"resume-text"}>{displayData.join(", ")}</span>
          </Col>
          <Col span={12}>
            <span className={"resume-subtitle"}>Prestations</span>
            <span className={"resume-text"} style={{ display: "flex" }}>
              {prestations.length > 5 ? (
                <Collapse size={"small"} style={{ width: "100%" }}>
                  <Collapse.Panel key={"all"} header={"Tout afficher"}>
                    {[...prestations]
                      ?.sort((a, b) => {
                        return a?.reference - b?.reference;
                      })
                      .map(e => {
                        console.log(e);

                        return renderLinkHasAccess(e) ? (
                          <Link
                            to={routes.prestations(e._id).detail.path}
                            style={{ flex: 1 }}
                          >
                            {e.reference}{" "}
                          </Link>
                        ) : (
                          <>{e.reference} </>
                        );
                      })}
                  </Collapse.Panel>
                </Collapse>
              ) : (
                <span>
                  {prestations.map(e => {
                    return renderLinkHasAccess(e) ? (
                      <Link
                        to={routes.prestations(e._id).detail.path}
                        style={{ flex: 1 }}
                      >
                        {e.reference}{" "}
                      </Link>
                    ) : (
                      e.reference
                    );
                  })}{" "}
                </span>
              )}
            </span>
          </Col>
          {userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }) && (
            <>
              {comment?.length > 0 && (
                <Col span={12}>
                  <span className={"resume-subtitle"}>
                    Commentaire facturation (privé)
                  </span>
                  <span className={"resume-text"}>{comment}</span>
                </Col>
              )}
            </>
          )}
          <>
            {comment_institution?.length > 0 && (
              <Col span={12}>
                <span className={"resume-subtitle"}>
                  Commentaire facturation (pour l'institution)
                </span>
                <span className={"resume-text"}>{comment_institution}</span>
              </Col>
            )}
          </>
          <>
            <Col span={12}>
              <span className={"resume-subtitle"}>Address de facturation</span>
              <span className={""}>
                {bill.institution?.groupedBilling === true ? (
                  <>
                    {bill.prestationsRef.billing === undefined &&
                      renderAdress(
                        bill.institution.defaultAddress,
                        true,
                        bill.institution,
                      )}

                    {bill.prestationsRef.billing !== undefined &&
                      renderAdress(
                        bill.prestationsRef.billing,
                        false,
                        bill.institution,
                      )}
                  </>
                ) : (
                  <>{prestations.map(pres => renderAdress(pres.billing))}</>
                )}
              </span>
            </Col>
          </>
        </Row>
      </>
    );
  };

  return (
    <>
      {bill !== null && (
        <CustomCard
          key={bill?._id}
          title={
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {title}

              {bill.institution?.groupedBilling === true ? (
                <Tag color={colorPrimary}>Facture groupée</Tag>
              ) : null}
            </span>
          }
          loading={loading}
        >
          {renderInformations()}
        </CustomCard>
      )}

      <br />
    </>
  );
};
